import { useState, useEffect } from 'react';
import api from '../../services/api';
import { API_ROUTES } from '../../services/apiRoutes';

export const useFetchDatarooms = (token) => {
    const [datarooms, setDatarooms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const fetchDatarooms = async () => {
            if (!token) return;

            try {
                const response = await api.get(API_ROUTES.ADMIN_GET_DATAROOMS, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (isMounted) {
                    setDatarooms(response.data);
                }
            } catch (error) {
                if (isMounted) {
                    setError(error.message || "Error fetching datarooms");
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchDatarooms();

        return () => {
            isMounted = false;
        };
    }, [token]);

    return { datarooms, loading, error, setDatarooms };
};